import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuranCalligraphiesQuranService } from './quran-calligraphies-quran.service';
import { QuranCalligraphyDto } from '../../shared/models/holy-quran/holy-quran-base.dto';
import { BehaviorSubject, switchMap, tap } from 'rxjs';
import { BrowsePaginatorComponent } from '../../features/browse-index/components/browse-paginator/browse-paginator.component';
import { BreadCrump } from '../../shared/bread-crump/bread-crump';
import { PaginationState, BrowseIndexItem } from '../../features/browse-index/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { IndexCardComponent } from '../../features/browse-index/components/index-card/index-card.component';
import { BiblioMapper } from '../../features/browse-index/mappers/biblio.mapper';

@Component({
  selector: 'app-quran-calligraphies-quran',
  standalone: true,
  imports: [CommonModule, BrowsePaginatorComponent, BreadCrump, IndexCardComponent, TranslateModule],
  templateUrl: './quran-calligraphies-quran.html',
  styleUrl: './quran-calligraphies-quran.scss',
})
export class QuranCalligraphiesQuran implements OnInit {
  private service = inject(QuranCalligraphiesQuranService);
  private route = inject(ActivatedRoute);
  public translateService = inject(TranslateService);

  private page$ = new BehaviorSubject<number>(1);
  private pageSize = 9;

  qurans: BrowseIndexItem[] = [];
  calligraphy: QuranCalligraphyDto | null = null;
  loading = signal<boolean>(false)
  pagination: PaginationState = {
    currentPage: 1,
    pageSize: 9,
    totalCount: 0,
    totalPages: 0
  };

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.service.getCalligraphyById(+id).subscribe(res => {
        this.calligraphy = res;
      });

      this.page$.pipe(
        tap(() => this.loading.set(true)),
        switchMap(page => this.service.getHolyQuransByCalligraphy(+id, page, this.pageSize))
      ).subscribe((res) => {
        this.qurans = BiblioMapper.toModelList(res.result) || [];
        this.pagination = {
          currentPage: this.page$.value,
          pageSize: this.pageSize,
          totalCount: res.totalElements,
          totalPages: Math.ceil(res.totalElements / this.pageSize) || 0
        };
        this.loading.set(false);
      });
    }
  }

  onPageChange(page: number): void {
    this.page$.next(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
